import { render, staticRenderFns } from "./BaseBanner.vue?vue&type=template&id=57078a5e&scoped=true&"
import script from "./BaseBanner.vue?vue&type=script&lang=js&"
export * from "./BaseBanner.vue?vue&type=script&lang=js&"
import style0 from "./BaseBanner.vue?vue&type=style&index=0&id=57078a5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57078a5e",
  null
  
)

export default component.exports